import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SiteSettingsService } from '../../shared/services/site-settings.service';

export const travelSubSwitchGuard: CanActivateFn = () => {
  const siteSettingService = inject(SiteSettingsService);
  const router = inject(Router);

  return siteSettingService.fetchSiteSettings().pipe(
    map((siteSettings) => {
      const enabled =
        siteSettings.switches.travel_hotels_module ||
        siteSettings.switches.travel_flights_module ||
        siteSettings.switches.travel_car_hire_module ||
        siteSettings.switches.travel_activities_module ||
        siteSettings.travel_services.length > 0;

      if (!enabled) {
        router.navigate(['/error/not-found']);
        return false;
      }
      return true;
    })
  );
};
